import { Box } from '@mui/material';
import { colors } from '../../../styles/colors';
import MoodIcon from '@mui/icons-material/Mood';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SyncIcon from '@mui/icons-material/Sync';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import GroupIcon from '@mui/icons-material/Group';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import { SvgIconComponent } from '@mui/icons-material';

interface StatusChipProps {
  status: string;
}

interface StatusConfig {
  icon: SvgIconComponent;
  color: string;
  label: string;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  PENDING: { icon: HourglassEmptyIcon, color: colors.brand.textSecondary, label: 'Pendente' },
  WAITING: { icon: GroupIcon, color: colors.primary.yellow, label: 'Aguardando' },
  RUNNING: { icon: SyncIcon, color: colors.status.running, label: 'Processando' },
  CONCLUDED: { icon: MoodIcon, color: colors.status.concluded, label: 'Concluído' },
  FAILED: { icon: SentimentVeryDissatisfiedIcon, color: colors.status.rejected, label: 'Falho' },
  SKIPPED: { icon: SkipNextIcon, color: '#F97316', label: 'Ignorado' },
};

export const StatusChip = ({ status }: StatusChipProps) => {
  const config = STATUS_CONFIG[status?.toUpperCase()] ?? STATUS_CONFIG.PENDING;
  const { icon: Icon, color, label } = config;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.625,
        height: 22,
        px: 1,
        borderRadius: '999px',
        border: `1px solid ${color}55`,
        backgroundColor: `${color}14`,
        color,
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: '10px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
      }}
    >
      <Icon sx={{ color: `${color} !important`, fontSize: '12px' }} />
      {label}
    </Box>
  );
};
